import Int32LookupRequestListResultModelBase from '../_generated/modelBases/int32-lookup-request-list-result-model-base';

export default class Int32LookupRequestListResultModel extends Int32LookupRequestListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
